const WifiIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#3982C2"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.04166 9.375L3.12499 11.4583C8.30207 6.28125 16.6979 6.28125 21.875 11.4583L23.9583 9.375C17.6354 3.05208 7.37499 3.05208 1.04166 9.375ZM9.37499 17.7083L12.5 20.8333L15.625 17.7083C13.9062 15.9792 11.1042 15.9792 9.37499 17.7083ZM5.20832 13.5417L7.29166 15.625C10.1667 12.75 14.8333 12.75 17.7083 15.625L19.7917 13.5417C15.7708 9.52083 9.23957 9.52083 5.20832 13.5417Z" />
  </svg>
)

export default WifiIcon
